import React, { createContext } from "react";

import { noop } from "lodash/fp";

import useLocalStorage from "@app/common/hooks/useLocalStorage";

interface DailyReadContextProviderProps {
  children: React.ReactNode;
}

interface PersistedDailyReadContext {
  lastMinimizedId: string | null;
  lastPlayedId: string | null;
  lastListenedId: string | null;
}

interface DailyReadContext extends PersistedDailyReadContext {
  updateDailyReadState: (fields: Partial<PersistedDailyReadContext>) => void;
}

const DEFAULT_CONTEXT: DailyReadContext = {
  lastMinimizedId: null,
  lastPlayedId: null,
  lastListenedId: null,
  updateDailyReadState: noop,
};

export const DailyReadContext =
  createContext<DailyReadContext>(DEFAULT_CONTEXT);

export const DailyReadContextProvider = ({
  children,
}: DailyReadContextProviderProps) => {
  const [persistedDailyReadMetadata, setPersistedDailyReadMetadata] =
    useLocalStorage<PersistedDailyReadContext>("dailyRead", DEFAULT_CONTEXT);

  const updateDailyReadState = (fields: Partial<PersistedDailyReadContext>) => {
    setPersistedDailyReadMetadata((state) => ({
      ...state,
      ...fields,
    }));
  };

  const context = {
    ...persistedDailyReadMetadata,
    updateDailyReadState,
  };

  return (
    <DailyReadContext.Provider value={context}>
      {children}
    </DailyReadContext.Provider>
  );
};
